<template>
  <Progressor :percent="percent" :type="item.type" :status="item.status">
    <div v-html="item.prompt" class="w-100 h-100"></div>
  </Progressor>
</template>
<script>
import Progressor from './Progressor';

export default {
  name: 'Timer',
  props: ['item'],
  emits: ['onTimeout'],
  components: {Progressor},
  data() {
    return {
      running: true,
      progress: window.timerProgress || 0,
      target: this.item.value * 100
    }
  },
  methods: {
    toggle: function() {
      if (process.env.NODE_ENV !== 'production')
        this.running = !this.running;
    }
  },
  unmounted() {
    window.removeEventListener('toggle-timer', this.toggle);
    clearInterval(this.interval);
    if (this.item.status === 'INDETERMINATE')
      window.timerProgress = this.progress;
    else
      delete window.timerProgress;
  },
  mounted() {
    window.addEventListener('toggle-timer', this.toggle);
    // if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => {
      if (!this.running)
        return;
/*
      if (this.progress > this.target/2)
        clearInterval(this.interval);
*/
      if (this.progress < this.target)
        return this.progress++;
      if (this.item.status === 'INDETERMINATE')
        this.progress=0;
      else
        clearInterval(this.interval);
      this.$emit('onTimeout');
/*
      // change-in-progress to trigger a submit on every tick instead of at the timeout.
      // This is to help with /create-quote type of loading pages but is causing too much network activity and also async debounce issues.
      if (this.progress++ > this.target)
        clearInterval(this.interval);
      if (this.progress % 100 === 0)
        this.$emit('onTimeout');
*/
    }, 10);
  },    
  computed: {
    percent: function () {
      return (100 * this.progress / this.target) + '%'
    }
  }
}
</script>